import { render } from "./meeting.vue?vue&type=template&id=746a40c2"
import script from "./meeting.vue?vue&type=script&lang=ts"
export * from "./meeting.vue?vue&type=script&lang=ts"
script.render = render

export default script